import { render, staticRenderFns } from "./EsopMaterialList.vue?vue&type=template&id=6876b1f5&"
import script from "./EsopMaterialList.vue?vue&type=script&lang=js&"
export * from "./EsopMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports